export default "__VITE_ASSET__Dn_4K85t__"